import React from 'react';
import { useTranslation } from 'react-i18next';
import { rwLabel } from '@/constants/remoteWork';

export const JobWorkInfo = ({ job }) => {
  const { i18n } = useTranslation();
  const L = (k) => rwLabel(i18n.language, k);
  const items = [
    [L('workMode'), L(job.work_mode || 'presencial'), 'workmode'],
    job.contract_type ? [L('contractType'), L(job.contract_type), 'contract'] : null,
    job.languages?.length ? [L('languages'), job.languages.map(L).join(', '), 'languages'] : null,
  ].filter(Boolean);
  return (
    <dl className="mt-2.5 grid grid-cols-1 sm:grid-cols-3 gap-2.5" data-testid="job-work-info">
      {items.map(([label, value, key]) => (
        <div key={key} className="rounded-lg border border-slate-200 bg-white px-3 py-2.5">
          <dt className="text-[11px] uppercase tracking-wide font-semibold text-slate-500 mb-0.5">{label}</dt>
          <dd className="text-[14px] font-semibold text-slate-900 leading-tight" data-testid={`job-info-${key}`}>{value}</dd>
        </div>
      ))}
    </dl>
  );
};
